import {
  GridContainer,
  GridItem,
  ButtonSpg,
  SimpleConfirmDialog,
  AsyncCallArgs,
  useAsyncCall,
} from "@duosoftbg/nacid-components";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ARUniEntryRequestStatus } from "../../../../../../utils/constants";
import { useState } from "react";
import { toast } from "react-toastify";
import { acceptARUniEntryRequest, rejectARUniEntryRequest } from "../../../../../../axios/api/services";
import { useNavigate } from "react-router-dom";

const ARUniEntryRequestsAdminActions = ({ data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { asyncCall } = useAsyncCall();
  const [openReject, setOpenReject] = useState(false);
  const [openAccept, setOpenAccept] = useState(false);

  const rejectRequest = (id) => {
    const asyncCallArgs: AsyncCallArgs = {
      processResponseErrors: false,
      promise: rejectARUniEntryRequest(id),
      onSuccess: () => {
        navigate("/admin-console/ar-uni-entry-request");
        toast.success(t("m.arUniEntryRequest.reject.request.success"));
      },
      onError: () => {
        toast.error(t("m.generic.error.service.fail"));
      },
    };
    asyncCall(asyncCallArgs);
    setOpenReject(false);
  };

  const acceptRequest = (id) => {
    const asyncCallArgs: AsyncCallArgs = {
      processResponseErrors: false,
      promise: acceptARUniEntryRequest(id),
      onSuccess: () => {
        navigate("/admin-console/ar-uni-entry-request");
        toast.success(t("m.arUniEntryRequest.accept.request.success"));
      },
      onError: () => {
        toast.error(t("m.generic.error.service.fail"));
      },
    };
    asyncCall(asyncCallArgs);
    setOpenAccept(false);
  };

  return (
    <GridContainer>
      <GridItem sm={12} md={12}>
        <Typography align={"center"}>
          {data.requestStatus?.id === ARUniEntryRequestStatus.SUBMITTED && (
            <>
              <ButtonSpg variant={"contained"} color={"error"} onClick={() => setOpenReject(true)}>
                {t("l.button.deny.arUniEntryRequest")}
              </ButtonSpg>
              <ButtonSpg variant={"contained"} ml={4} onClick={() => setOpenAccept(true)}>
                {t("l.button.accept.arUniEntryRequest")}
              </ButtonSpg>
            </>
          )}
        </Typography>
      </GridItem>
      <SimpleConfirmDialog
        open={openReject}
        setOpen={setOpenReject}
        alertType={"warning"}
        alertText={"m.arUniEntryRequest.reject.request.warn"}
        dialogTitleText={"t.arUniEntryRequest.confirm.dialog"}
        onConfirm={() => rejectRequest(data.id)}
      />
      <SimpleConfirmDialog
        open={openAccept}
        setOpen={setOpenAccept}
        alertType={"warning"}
        alertText={"m.arUniEntryRequest.accept.request.warn"}
        dialogTitleText={"t.arUniEntryRequest.confirm.dialog"}
        onConfirm={() => acceptRequest(data.id)}
      />
    </GridContainer>
  );
};
export default ARUniEntryRequestsAdminActions;
